module.exports = __webpack_public_path__ + "static/media/ic_alipay.45123fa0.svg";